import React from "react";

export function useMediaQuery(query: string) {
  const [matches, setMatches] = React.useState(false);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    if (mediaQuery.matches !== matches) {
      setMatches(mediaQuery.matches);
    }
    const listener = () => {
      setMatches(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", listener);
    return () => mediaQuery.removeEventListener("change", listener);
  }, [matches, query]);

  return matches;
}

const TABLET_BREAKPOINT = "(min-width: 768px)";
const TABLET_LARGE_BREAKPOINT = "(min-width: 1024px)";
const DESKTOP_BREAKPOINT = "(min-width: 1200px)";
const DESKTOP_LARGE_BREAKPOINT = "(min-width: 1920px)";

export function useTabletMediaQuery(): boolean {
  return useMediaQuery(TABLET_BREAKPOINT);
}

export function useTabletLargeMediaQuery(): boolean {
  return useMediaQuery(TABLET_LARGE_BREAKPOINT);
}

export function useDesktopMediaQuery(): boolean {
  return useMediaQuery(DESKTOP_BREAKPOINT);
}

export function useDesktopLargeMediaQuery(): boolean {
  return useMediaQuery(DESKTOP_LARGE_BREAKPOINT);
}
